import React from "react";
import Marquee from "react-fast-marquee";
import { BiSearch } from "react-icons/bi";
import useAuth from "../../Hooks/useAuth";

const Banner = () => {
  const {showDummyImage} = useAuth()
  return (
    <div className="banner">
      <div className="container">
        <div className="banner-wrapper">
          <span>Create Explore & Collect Digital Art NFTs</span>
          <h2>NFT Marketplace</h2>
          <form onSubmit={(e)=> e.preventDefault()} className="banner-search-bar outline">
            <input
              type="text"
              placeholder="Search by collection, NFT or user"
            />
            <button>
              <BiSearch />
            </button>
          </form>
        </div>
      </div>
      <div className="banner-imgs">
        <div className="banner-solt-one">
          <Marquee>
          <div className="banner-img">
            <img src={require("../../assets/images/home/banner_img_1.png")} alt={'bannerImgOne'} onError={({currentTarget},imageSize='190X140')=>showDummyImage({currentTarget},imageSize)}/>
          </div>
          <div className="banner-img">
            <img src={require("../../assets/images/home/banner_img_2.png")} alt={'bannerImgTwo'} onError={({currentTarget},imageSize='190X140')=>showDummyImage({currentTarget},imageSize)}/>
          </div>
          <div className="banner-img">
            <img src={require("../../assets/images/home/banner_img_3.png")} alt={'bannerImgThree'} onError={({currentTarget},imageSize='190X140')=>showDummyImage({currentTarget},imageSize)}/>
          </div>
          <div className="banner-img">
            <img src={require("../../assets/images/home/banner_img_4.png")} alt={'bannerImgThree'} onError={({currentTarget},imageSize='190X140')=>showDummyImage({currentTarget},imageSize)}/>
          </div>
           <div className="banner-img">
            <img src={require("../../assets/images/home/banner_img_5.png")} alt={'bannerImgThree'} onError={({currentTarget},imageSize='190X140')=>showDummyImage({currentTarget},imageSize)}/>
          </div>
           <div className="banner-img">
            <img src={require("../../assets/images/home/banner_img_6.png")} alt={'bannerImgThree'} onError={({currentTarget},imageSize='190X140')=>showDummyImage({currentTarget},imageSize)}/>
          </div>
          </Marquee>
        </div>
        <div className="banner-solt-two">
          <Marquee direction="right">
            <div className="banner-img">
            <img src={require("../../assets/images/home/banner_img_7.png")} alt={'bannerImgFive'} onError={({currentTarget},imageSize='260X145')=>showDummyImage({currentTarget},imageSize)} />
          </div>
          <div className="banner-img">
            <img src={require("../../assets/images/home/banner_img_8.png")} alt={'bannerImgFour'} onError={({currentTarget},imageSize='260X145')=>showDummyImage({currentTarget},imageSize)}/>
          </div>
          <div className="banner-img">
            <img src={require("../../assets/images/home/banner_img_9.png")} alt={'bannerImgFive'} onError={({currentTarget},imageSize='260X145')=>showDummyImage({currentTarget},imageSize)} />
          </div>
           <div className="banner-img">
            <img src={require("../../assets/images/home/banner_img_10.png")} alt={'bannerImgFive'} onError={({currentTarget},imageSize='260X145')=>showDummyImage({currentTarget},imageSize)} />
          </div>
          </Marquee>
        </div>
      </div>
    </div>
  );
};

export default Banner;